import { useTranslation } from 'react-i18next';
import { CircleCheckIcon } from '@c2fo/liquidity/icons';

const TOTAL_STEPS = 3;

interface ActivationProgressProps {
  completedSteps: number;
}

// Hand-rolled: Liquidity has no progress/stepper primitive .
const ActivationProgress = ({ completedSteps }: ActivationProgressProps) => {
  const { t } = useTranslation();

  if (completedSteps >= TOTAL_STEPS) {
    return (
      <div className="flex flex-col gap-4 rounded-xl border border-primary-500 bg-canvas-green px-4 py-6">
        <div className="flex flex-col gap-3 md:flex-row md:items-center">
          <div className="flex flex-1 items-center gap-3">
            <CircleCheckIcon className="size-16 shrink-0 fill-primary-500" />
            <div className="flex flex-1 flex-col">
              <span className="text-2xl font-bold text-text-primary">
                {t('instantPay.onboarding.activationComplete.title')}
              </span>
              <span>{t('instantPay.onboarding.activationComplete.description')}</span>
            </div>
          </div>
          <span>
            {t('instantPay.onboarding.progress.stepsComplete', { completed: completedSteps, total: TOTAL_STEPS })}
          </span>
        </div>
        <div className="h-2.5 w-full overflow-hidden rounded-full bg-gray-200">
          <div
            className="h-full w-full rounded-full bg-primary-500"
            role="progressbar"
            aria-valuenow={completedSteps}
            aria-valuemin={0}
            aria-valuemax={TOTAL_STEPS}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3 rounded-xl bg-white p-4">
      <div className="flex items-center justify-between">
        <span className="font-medium text-text-primary">{t('instantPay.onboarding.progress.title')}</span>
        <span>
          {t('instantPay.onboarding.progress.stepsComplete', { completed: completedSteps, total: TOTAL_STEPS })}
        </span>
      </div>
      <div className="h-2.5 w-full overflow-hidden rounded-full bg-gray-200">
        <div
          className="h-full rounded-full bg-primary-500 transition-all"
          style={{ width: `${(completedSteps / TOTAL_STEPS) * 100}%` }}
          role="progressbar"
          aria-valuenow={completedSteps}
          aria-valuemin={0}
          aria-valuemax={TOTAL_STEPS}
        />
      </div>
    </div>
  );
};

export default ActivationProgress;
